import React from 'react';
import { checkPixel } from 'utils';
import * as Icons from 'assets/icons';
import styled from 'styled-components';
import { Span } from 'styles';

export function Icon({ name, onClick, ...props }) {
  const IconComponent = Icons[name];

  if (!IconComponent) {
    return null;
  }

  return (
    <Container {...props} onClick={onClick}>
      <IconComponent className="icon" />
    </Container>
  );
}

const Container = styled(Span)`
  display: inline-block;
  line-height: 0;
  transition: opacity 150ms ease;

  .icon {
    ${({ $width }) => $width && `width:${checkPixel($width)}`};
    ${({ $height }) => $height && `height:${checkPixel($height)}`};
    ${({ $fill, theme }) => $fill && `fill:${theme.colors[$fill] || $fill}`};
    ${({ $stroke, theme }) => $stroke && `stroke:${theme.colors[$stroke] || $stroke}`};
    & path {
      ${({ $pathFill, theme }) => $pathFill && `fill:${theme.colors[$pathFill] || $pathFill}`};
      ${({ $pathStroke, theme }) => $pathStroke && `stroke:${theme.colors[$pathStroke] || $pathStroke}`};
      ${({ $pathOpacity }) => $pathOpacity && `fill-opacity:${$pathOpacity}`};
    }
    & rect {
      ${({ $rectFill, theme }) => $rectFill && `fill:${theme.colors[$rectFill] || $rectFill}`};
    }
  }
`;
